import type { TFunction } from "i18next"

/** How long, at the density a table cell is read at: 45m, 47h, 26d. */
export const formatElapsed = (seconds: number | null | undefined, t: TFunction): string => {
  if (seconds == null || seconds < 0) return "—"
  if (seconds < 60) return t("esign.tracking.duration.lessThanMinute")
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return t("esign.tracking.duration.minutes", { count: minutes })
  const hours = Math.floor(minutes / 60)
  if (hours < 48) return t("esign.tracking.duration.hours", { count: hours })
  return t("esign.tracking.duration.days", { count: Math.floor(hours / 24) })
}
